module.exports = __webpack_public_path__ + "img/2ea3b6e.png";